import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import { merchantApi } from "@api";
import {
    ArrowLeftColor,
    BigLinkIcon,
    ComponentPaymentDrwaer,
    ComponentRemoveCardModal,
    ComponentSuccessModal,
    IConClose,
    IconAddMoney,
    IconCheck3,
    IconLink,
    PaymentIcon,
    TransferCirclrIcon,
} from "@components";
import { IDeleteCard, ILinkCard, ITransferCard } from "@interfaces";
import { selectAuth, selectMerchant, setLoading } from "@redux";
import { RenderMeta, formatMessage, useNotify } from "@utils";
import { Button, Collapse, Input, Switch, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { LockCardIcon } from "src/Components/icon/LockIcon";
import { SuccessIcon } from "src/Components/icon/SuccessIcon";
import { formatDateDefault, formatDisplayMonthYear } from "src/Utils/dateUtil";
// import socket from "src/Utils/socketIoTopUp";
import styled from "styled-components";
const { TabPane } = Tabs;

interface IValue {
    card_num: string;
    card_secret: string;
}

interface ICard {
    cardId: string;
    cardCash: string;
    cardExp: string;
    cardNumber: string;
    imageUrl: string[];
    secretNumber: string;
    isDefault: boolean;
    isDelete: boolean;
    isOnline: boolean;
    isTopup: boolean;
    isAllmember: boolean;
    initialAmount: number;
    maxUsePertime: number;
    isUseLimit: boolean;
    typeUsegeLimit: string;
    fixUsePertime: string;
    isPhysical: boolean;
    cardPhysicNumber?: string;
    secretPhysicNumber?: string;
    isFreeze: boolean;
}

const INIT_DATA = {
    card_num: "",
    card_secret: "",
};

export const PageCardMember = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams<{ id: string }>();
    const orgID = useSelector(selectMerchant)._id;
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor;
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const { success, error, warning } = useNotify();
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<IValue>(INIT_DATA);
    const [cardList, setCardList] = useState<ICard[]>([]);
    const [focusIndex, setFocusIndex] = useState<number>(0);
    const [menuTab, setMenuTab] = useState<number>(1);
    const [showTransfer, setShowTransfer] = useState<boolean>(false);
    const [showPhysical, setShowPhysical] = useState<boolean>(false);
    const [selectTrans, setSelectTrans] = useState<number | null>(null);
    const [isConTrans, setIsConTrans] = useState<boolean>(false);
    const [transAmount, setTransAmount] = useState<string>("");
    const [successTrans, setSuccessTrans] = useState<boolean>(false);
    const [showRemove, setShowRemove] = useState<boolean>(false);
    const [showPayment, setShowPayment] = useState<boolean>(false);
    const [phyValue, setPhyValue] = useState<IValue>(INIT_DATA);
    const [historyList, setHistoryList] = useState<any[]>([]);
    const [isShowPopup, setIsShowPopup] = useState<boolean>(false);
    const [isPaymentProcess, setIsPaymentProcess] = useState<boolean>(false);
    const [isPaymentSuccess, setIsPaymentSuccess] = useState<boolean>(false);
    const today = new Date();

    useEffect(() => {
        // if (userInfo) {
        //     socket.connect();
        //     socket.off("topup_success");
        //     // socket.emit('pong', {test_string: 'test123'}, function (data: any) {
        //     //   console.log('pong: ', JSON.stringify(data));
        //     // });
        //     // socket.on('ping', function (data: any) {
        //     //   console.log('ping: ', JSON.stringify(data));
        //     // });
        //     socket.emit(
        //         "joinProfileRoom",
        //         { profile_id: userInfo.contact?.userId },
        //         function (data: any) {
        //             console.log("joinProfileRoom: ", JSON.stringify(data));
        //             if (data.error === "0") {
        //                 console.log("join ok");
        //             } else {
        //                 console.log("err: ", data.msg);
        //             }
        //         }
        //     );
        //     socket.on("topup_success", function (message: any) {
        //         console.log("ON: ", message.result);
        //         fetchCard();
        //         setIsPaymentProcess(false);
        //         setIsPaymentSuccess(true);
        //         setTimeout(() => setIsPaymentSuccess(false), 500);
        //     });
        // }
        // return () => {
        //     socket.off("topup_success", function (message: any) {
        //         console.log("OFF: ", message.result);
        //     });
        //     socket.disconnect();
        // };
    }, [userInfo]);

    useEffect(() => {
        fetchCard();
    }, []);

    useEffect(() => {
        if (!open) {
            setValue(INIT_DATA);
        }
    }, [open]);

    function formatShowDate(date: any) {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        // if (month.length < 2) month = '0' + month;
        // if (day.length < 2) day = '0' + day;
        return [day, month, year].join("/");
    }
    function formatShowTime(date: any) {
        let d = new Date(date),
            hour = "" + d.getHours(),
            minute = "" + d.getMinutes();

        if (minute.length < 2) minute = "0" + minute;
        let outTime = [hour, minute].join(":");
        return outTime;
    }

    const fetchCard = async () => {
        try {
            dispatch(setLoading(true));
            // let payload
            await merchantApi.createCardAuto();
            let user_id = userInfo?._id || "";
            let res = await merchantApi.getCardList(user_id);
            let cardArr: ICard[] = [];
            let card_id = "";
            res?.data?.forEach((cItem: any, cIndex: number) => {
                if (cItem?.isAllmember) {
                    setFocusIndex(cIndex);
                    if (cItem?._id) {
                        card_id = cItem?._id;
                    }
                }
                cardArr.push({
                    cardId: cItem._id,
                    cardCash: cItem.cardCash,
                    cardExp: cItem.cardExp,
                    cardNumber: cItem.cardNumber,
                    imageUrl: cItem.imageUrl,
                    secretNumber: cItem.secretNumber,
                    isDefault: cItem.isDefault,
                    isDelete: cItem.isDelete,
                    isOnline: cItem.isOnline || false,
                    isTopup: cItem.isTopup,
                    isAllmember: cItem?.isAllmember,
                    initialAmount: Number(cItem.initialAmount),
                    maxUsePertime: Number(cItem.maxUsePertime),
                    isUseLimit: cItem?.isUseLimit || false,
                    typeUsegeLimit: cItem?.typeUsegeLimit,
                    fixUsePertime: cItem?.fixUsePertime,
                    isPhysical: cItem?.isPhysical || false,
                    cardPhysicNumber: cItem?.cardPhysicNumber,
                    secretPhysicNumber: cItem?.secretPhysicNumber,
                    isFreeze: cItem?.isFreeze || false,
                });
            });
            if (card_id !== "") {
                const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                let res = await merchantApi.getCardHistory({
                    organization_id: orgID || "",
                    client_id: userInfo?._id || "",
                    xpage: 1,
                    xlimit: 99,
                    date_from: formatDateDefault(firstDay),
                    date_to: formatDateDefault(lastDay),
                    card_id: card_id,
                });
                setHistoryList(res?.data?.result);
            }
            setCardList([...cardArr]);
        } catch (err: any) {
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const confirmLink = async () => {
        if (!phyValue.card_num || !phyValue.card_secret) {
            warning(t("page.all_fields_are_required"));
        } else
            try {
                dispatch(setLoading(true));
                // let res = await merchantApi
                let payload: ILinkCard = {
                    cardNumber: phyValue.card_num,
                    secretNumber: phyValue.card_secret,
                    oldCardNumber: cardList[focusIndex]?.cardNumber,
                    oldSecretNumber: cardList[focusIndex]?.secretNumber,
                };
                let res = await merchantApi.linkCard(payload);
                if (res.data.status === "200") {
                    success(res.data.msg);
                    setOpen(false);
                    setShowPhysical(false);
                    fetchCard();
                } else {
                    error(res.data.err);
                }

                // if (res.status === 201) {
                //     success(res.data.msg);
                //     setOpen(false);
                // } else {
                //     error(res.data.msg);
                // }
            } catch (err: any) {
                error(formatMessage(err.response));
            } finally {
                dispatch(setLoading(false));
            }
    };
    const confirmUnlink = async () => {
        try {
            dispatch(setLoading(true));
            let res = await merchantApi.unlinkCard({
                cardPhysicNumber: cardList[focusIndex]?.cardPhysicNumber || "",
                secretPhysicNumber: cardList[focusIndex]?.secretPhysicNumber || "",
            });
            success(formatMessage(res));
            setIsShowPopup(false);
            fetchCard();
        } catch (err: any) {
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const clickTransfer = () => {
        setShowTransfer(true);
    };

    const clickPhysical = () => {
        if (cardList[focusIndex]?.isPhysical) {
            return;
        } else setShowPhysical(true);
        // setIsShowPopup(true);
    };

    const closeTransfer = () => {
        setShowTransfer(false);
        setIsConTrans(false);
        setSelectTrans(null);
        setTransAmount("");
    };

    const closePhysical = () => {
        setShowPhysical(false);
        setPhyValue(INIT_DATA);
    };

    const changePhyValue = (e: any) => {
        let arr = {
            ...phyValue,
            [e.target.name]: e.target.value,
        };
        setPhyValue({ ...arr });
    };

    const clickDeactivate = () => {
        //
    };
    const clickRemove = () => {
        //
        setShowRemove(true);
    };

    const clickSelectTransfer = () => {
        if (selectTrans === null) {
            warning("Please select card");
        } else {
            setIsConTrans(true);
        }
    };

    const changeTransterAmount = (e: any) => {
        if (!isNaN(+e.target.value)) {
            setTransAmount(e.target.value);
        }
    };
    const confirmTranster = async () => {
        if (Number(transAmount) > Number(cardList[focusIndex]?.cardCash)) {
            error("Transfer Amount is More than card amount");
        } else {
            let payload: ITransferCard = {
                firstCardId: cardList[focusIndex]?.cardId,
                firstCardNumber: cardList[focusIndex]?.cardNumber,
                secondCardId: cardList[selectTrans || 0]?.cardId,
                secondCardNumber: cardList[selectTrans || 0]?.cardNumber,
                amount: transAmount,
                userId: userInfo?._id || "",
            };
            let res = await merchantApi.cardTransfer(payload);
            setSuccessTrans(true);
            closeTransfer();
        }
        //
    };

    const removeCard = async () => {
        setShowRemove(false);
        let payload: IDeleteCard = {
            cardNum: cardList[focusIndex]?.cardNumber,
            cardId: cardList[focusIndex]?.cardId,
        };
        let res = await merchantApi.deleteCard(payload);
        success("Delete Card Succes!");
    };
    const { Panel } = Collapse;

    const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

    const header = () => {
        return (
            <div className="layout-header-timeline">
                <div className="text">tees</div>
                <div className="text">1234</div>
            </div>
        );
    };

    const onChange = (key: string | string[]) => {
        //
    };

    return (
        <StyledReceiptPage themeColor={themes?.themeColor!}>
            <RenderMeta title={t("meta.cardmember_page")} />
            <div className="content">
                <div className="back-arrow">
                    <ArrowLeftColor onClick={() => history.push("/")} color={themes?.themeColor} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="main-card-section">
                    <div className="main-card">
                        {cardList[focusIndex]?.isFreeze && (
                            <div>
                                <div className="lockIcon">
                                    <div className="lockLayout">
                                        <LockCardIcon />
                                        <p className="lockText">Your card has been freeze.</p>
                                    </div>
                                </div>
                                <div className="cardOverlay" />
                            </div>
                        )}

                        <img src={cardList[focusIndex]?.imageUrl[0]} className="bg-card" />
                        <p className="card-num">
                            {cardList[focusIndex]?.isPhysical
                                ? cardList[focusIndex]?.cardPhysicNumber
                                : cardList[focusIndex]?.cardNumber}
                        </p>
                        <p className="card-mem">
                            {/* {cardList[focusIndex]?.isOnline && "Gift "} Card */}
                            {t("page.giftcard")}
                        </p>
                    </div>
                    <div className="main-price">
                        <div className="used">
                            {cardList[focusIndex]?.isUseLimit &&
                                cardList[focusIndex]?.typeUsegeLimit === "fixUsage" &&
                                !cardList[focusIndex]?.isTopup && (
                                    <>
                                        {(Number(cardList[focusIndex]?.initialAmount) -
                                            Number(cardList[focusIndex]?.cardCash)) /
                                            Number(cardList[focusIndex]?.fixUsePertime)}
                                        <span>
                                            /
                                            {Number(cardList[focusIndex]?.initialAmount) /
                                                Number(cardList[focusIndex]?.fixUsePertime)}
                                        </span>
                                        used
                                    </>
                                )}
                        </div>

                        <div className="price">
                            {new Intl.NumberFormat().format(
                                parseInt(cardList[focusIndex]?.cardCash || "0")
                            )}{" "}
                            {t("page.thb")}
                        </div>
                        {/* <div className="price">
                            {cardList[focusIndex]?.cardCash}
                            THB
                        </div> */}
                        {cardList[focusIndex]?.isTopup && (
                            <div
                                className="add-money"
                                onClick={() => {
                                    if (!cardList[focusIndex]?.isFreeze) setShowPayment(true);
                                }}
                            >
                                <IconAddMoney />
                                <p>{t("page.card.add_money")}</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="tab-section">
                    <div
                        className={menuTab === 0 ? "menu-active" : ""}
                        onClick={() => setMenuTab(0)}
                    >
                        {t("page.transactionhistory")}
                    </div>
                    <div
                        className={menuTab === 1 ? "menu-active" : ""}
                        onClick={() => setMenuTab(1)}
                    >
                        {t("page.settingcard")}
                    </div>
                </div>
                <div className="detail-section">
                    {menuTab === 0 && (
                        <>
                            <div className="layout-timeline">
                                <div className="title-timeline">
                                    {formatDisplayMonthYear(today)}
                                </div>
                                <Collapse defaultActiveKey={["0"]} onChange={onChange}>
                                    {historyList?.map((hItem, hIndex) => {
                                        return (
                                            <Panel
                                                key={hIndex}
                                                header={
                                                    <div className="layout-header-timeline">
                                                        <div className="layout-timedate-timeline">
                                                            <span className="date">
                                                                {formatShowDate(
                                                                    hItem?.created_date
                                                                )}
                                                            </span>
                                                            <span className="time">
                                                                {formatShowTime(
                                                                    hItem?.created_date
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className="layout-cash-timeline">
                                                            {hItem?.card_change_text}
                                                        </div>
                                                    </div>
                                                }
                                            >
                                                <div className="detail-timeline">
                                                    <p>No. Invoice : {hItem?.order_code}</p>
                                                    <p>Branch : {hItem?.store_name}</p>
                                                </div>
                                            </Panel>
                                        );
                                    })}
                                </Collapse>
                            </div>
                        </>
                    )}
                    {menuTab === 1 && (
                        <>
                            <div className="menu-section">
                                {/* <div className="menu-item">
                                <div className="icon-name">
                                    <DefaultCardIcon />
                                    <p>Default Card</p>
                                </div>
                                <Switch checked={cardList[focusIndex]?.isDefault} />
                            </div> */}
                                {cardList[focusIndex]?.isOnline &&
                                    cardList[focusIndex]?.isAllmember && (
                                        <div
                                            className="menu-item"
                                            onClick={() => {
                                                if (!cardList[focusIndex]?.isFreeze) {
                                                    clickPhysical();
                                                }
                                            }}
                                        >
                                            <div className="icon-name">
                                                <IconLink />
                                                <p style={{ color: themeColor }}>
                                                    {t("page.card.link_physical_card")}
                                                </p>
                                            </div>
                                            <div className="switch-link">
                                                {cardList[focusIndex]?.isPhysical && (
                                                    <IconCheck3 size={14} color="#5B835D" />
                                                )}
                                                {cardList[focusIndex]?.isPhysical && (
                                                    <div>
                                                        Linked
                                                        <span style={{ marginLeft: "5px" }}></span>
                                                    </div>
                                                )}

                                                <Switch
                                                    style={{
                                                        backgroundColor: cardList[focusIndex]
                                                            ?.isPhysical
                                                            ? "#5B835D"
                                                            : "",
                                                    }}
                                                    value={cardList[focusIndex]?.isPhysical}
                                                    // onChange={setIsLink}
                                                    onClick={() => {
                                                        if (
                                                            cardList[focusIndex]?.isPhysical &&
                                                            !cardList[focusIndex]?.isFreeze
                                                        ) {
                                                            setIsShowPopup(true);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                {/* {cardList[focusIndex]?.isTopup &&
                                    !cardList[focusIndex]?.isUseLimit && (
                                        <div
                                            className="menu-item"
                                            onClick={() => {
                                                if (!cardList[focusIndex]?.isFreeze) {
                                                    clickTransfer();
                                                }
                                            }}
                                        >
                                            <div className="icon-name">
                                                <TransferIcon />
                                                <p style={{ color: themeColor }}>
                                                    Transfer Balance
                                                </p>
                                            </div>
                                            <ArrowRight />
                                        </div>
                                    )} */}
                                {/* <div className="menu-item" onClick={clickDeactivate}>
                                <div className="icon-name">
                                    <DeactivateIcon />
                                    <p>Deactivate Card</p>
                                </div>
                                <ArrowRight />
                            </div> */}
                                {/* // remove card */}
                                {/* <div className="menu-item" onClick={clickRemove}>
                                    <div className="icon-name">
                                        <DeleteIcon />
                                        <p>Remove Card</p>
                                    </div>
                                    <ArrowRight />
                                </div> */}
                            </div>
                        </>
                    )}
                </div>
                {!showPayment && (
                    <StyledPayment
                        themeColor={themes?.themeColor!}
                        onClick={() => {
                            if (!cardList[focusIndex]?.isFreeze) {
                                setShowPayment(true);
                            }
                        }}
                    >
                        <PaymentIcon color={themes?.themeColor!} />
                        {/* <p>Payment {cardList[focusIndex]?.isTopup && "& Store top-up"} </p> */}
                        <p>{t("page.card.top_up")}</p>
                    </StyledPayment>
                )}

                <div>
                    {showTransfer && (
                        <StyledDrawer themeColor={themes?.themeColor!}>
                            <div className="content-layout">
                                <div className="content">
                                    <div className="header">
                                        <div className="header-name">Select Card to Transfer</div>
                                        <div className="close" onClick={closeTransfer}>
                                            <IConClose />
                                        </div>
                                    </div>

                                    <div className="input-section">
                                        <StyleTransfer themeColor={themes?.themeColor!}>
                                            {!isConTrans && (
                                                <>
                                                    {cardList.filter(
                                                        (cItem) =>
                                                            !cItem?.isAllmember &&
                                                            !cItem?.isUseLimit &&
                                                            !cItem?.isFreeze &&
                                                            !cItem?.isDelete
                                                    ).length < 1 && (
                                                        <div
                                                            style={{
                                                                textAlign: "center",
                                                                color: "#A6ACAF",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            {t("page.dataNotFound")}
                                                        </div>
                                                    )}
                                                    {cardList?.map((cItem, cIndex) => {
                                                        if (
                                                            !cItem?.isAllmember &&
                                                            !cItem?.isUseLimit &&
                                                            !cItem?.isFreeze &&
                                                            !cItem?.isDelete
                                                        ) {
                                                            return (
                                                                <div
                                                                    className={
                                                                        (selectTrans === cIndex &&
                                                                            "active-trans") +
                                                                        " card-section"
                                                                    }
                                                                    key={cIndex}
                                                                    onClick={() =>
                                                                        setSelectTrans(cIndex)
                                                                    }
                                                                >
                                                                    <img
                                                                        src={cItem?.imageUrl[0]}
                                                                        className="card-img"
                                                                    />
                                                                    <p>{cItem?.cardCash} THB</p>
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                    <Button
                                                        className="trans-btn"
                                                        onClick={clickSelectTransfer}
                                                    >
                                                        Transfer
                                                    </Button>
                                                </>
                                            )}
                                            {isConTrans && (
                                                <>
                                                    <div className="show-card-section">
                                                        <div className="img-div">
                                                            <img
                                                                src={
                                                                    cardList[focusIndex]
                                                                        ?.imageUrl[0]
                                                                }
                                                            />
                                                            <p>
                                                                {" "}
                                                                {cardList[focusIndex]?.cardCash} THB
                                                            </p>
                                                        </div>
                                                        <div className="tran-circle">
                                                            <TransferCirclrIcon
                                                                color={themes?.themeColor!}
                                                            />
                                                        </div>
                                                        <div className="img-div">
                                                            <img
                                                                src={
                                                                    cardList[selectTrans || 0]
                                                                        ?.imageUrl[0]
                                                                }
                                                            />
                                                            <p>
                                                                {" "}
                                                                {
                                                                    cardList[selectTrans || 0]
                                                                        ?.cardCash
                                                                }{" "}
                                                                THB
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p className="input-title">
                                                        Amount to transfer*
                                                    </p>
                                                    <Input
                                                        value={transAmount}
                                                        onChange={(e) => changeTransterAmount(e)}
                                                    />
                                                    <Button
                                                        className="trans-btn"
                                                        onClick={confirmTranster}
                                                    >
                                                        Confirm to Transfer
                                                    </Button>
                                                </>
                                            )}
                                        </StyleTransfer>
                                    </div>
                                </div>
                            </div>
                        </StyledDrawer>
                    )}
                    {successTrans && (
                        <ComponentSuccessModal handleCloseDetail={() => setSuccessTrans(false)} />
                    )}
                    {showRemove && (
                        <ComponentRemoveCardModal
                            handleCloseDetail={() => setShowRemove(false)}
                            removeCard={removeCard}
                        />
                    )}
                    {showPayment && (
                        <ComponentPaymentDrwaer
                            isShow={showPayment}
                            handleCloseDetail={() => setShowPayment(false)}
                            openPaymentProcess={() => setIsPaymentProcess(true)}
                            cardDetail={cardList[focusIndex]}
                            cardList={cardList}
                            focusIndex={focusIndex}
                            type=""
                        />
                    )}
                </div>
                <div>
                    {showPhysical && (
                        <StyledDrawer themeColor={themes?.themeColor!}>
                            <div className="content-layout">
                                <div className="content">
                                    <div className="header">
                                        <div className="header-name">Link Physical Card</div>
                                        <div className="close" onClick={closePhysical}>
                                            <IConClose />
                                        </div>
                                    </div>
                                    <div className="input-section">
                                        <p className="title">{t("page.card.phy_card_num")}</p>
                                        <Input
                                            className="card-input"
                                            name="card_num"
                                            placeholder={t("page.card.place_card_num")}
                                            value={phyValue.card_num}
                                            onChange={changePhyValue}
                                        />
                                        <p className="title">{t("page.card.phy_card_ser")}</p>
                                        <Input
                                            className="card-input"
                                            name="card_secret"
                                            placeholder={t("page.card.place_card_ser")}
                                            value={phyValue.card_secret}
                                            onChange={changePhyValue}
                                        />
                                        <Button className="add-btn" onClick={confirmLink}>
                                            + {t("page.card.link_card")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </StyledDrawer>
                    )}
                </div>
                {isShowPopup && (
                    <StyledPopupUnlink themeColor={themes?.themeColor!}>
                        <div className="box-popupconfirm">
                            <BigLinkIcon color={themes?.themeColor!} />
                            <div className="textTitle">{t("page.card.unlink_title")}</div>
                            <div className="textDesc">{t("page.card.unlink_role")}</div>
                            <div className="bottomLay">
                                <button onClick={() => setIsShowPopup(false)} className="btnClose">
                                    {t("page.close")}
                                </button>
                                <button onClick={() => confirmUnlink()} className="btnConfirm">
                                    {t("page.confirm")}
                                </button>
                            </div>
                        </div>
                    </StyledPopupUnlink>
                )}
                {isPaymentProcess && (
                    <Overlay>
                        <Content>
                            <Logo src={merchant?.themes?.logoSmallUrl} alt="Logo" />
                            <Text>{t("page.paymentProcessing")}</Text>
                        </Content>
                    </Overlay>
                )}
                {isPaymentSuccess && (
                    <StyledPopupPaymentSuccess>
                        <div className="box-popupconfirm">
                            <div className="img-popupconfirm">
                                {/* <img src="../images/img-gift.svg" alt="" /> */}
                            </div>
                            {/* <div className="text-order">Order number founded</div> */}

                            <div className="title">
                                <div>
                                    <SuccessIcon />
                                </div>
                                <div className="text-sub-header">Top-up success</div>
                            </div>
                        </div>
                    </StyledPopupPaymentSuccess>
                )}
            </div>

            {/* <div className="empty-space" /> */}
        </StyledReceiptPage>
    );
};

const StyledPayment = styled.div<{ themeColor: string }>`
    cursor: pointer;
    position: -webkit-sticky;
    position: sticky;
    z-index: 999;
    bottom: 10px;
    width: 130px;
    // height: 50px;
    margin-left: auto;
    margin-right: 15px;
    padding: 10px;
    text-align: center;
    svg {
        margin-left: 15px;
    }
    p {
        color: ${(p) => p.themeColor};
        margin-left: 10px;
        margin-top: 5px;
        font-weight: 600;
        font-size: 14px;
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100vh;
    overflow: hidden;
    .content {
        background-image: url(../../images/bg-card-detail.png);
        background-position: top left;
        background-repeat: no-repeat;
        background-size: contain;
        .back-arrow {
            display: flex;
            padding: 20px 16px;
            align-items: center;
            span {
                margin-left: 10px;
                color: ${(p) => p.themeColor};
            }
        }
        .icon-back {
            padding: 20px;
            cursor: pointer;
        }
        .main-card-section {
            margin: 10px 20px 15px;
            display: grid;
            grid-template-columns: 60% 35%;
            grid-gap: 20px;
            @media (max-width: 400px) {
                grid-template-columns: none;
            }
            .main-card {
                border-radius: 20px;
                height: 150px;
                box-shadow: 0px 0px 10px 1px #0000001f;
                position: relative;
                .bg-card {
                    position: absolute;
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 20px;
                }
                .lockIcon {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 1000;
                }
                .lockLayout {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                }
                .lockText {
                    color: #fff;
                    font-size: 10px;
                    font-style: normal;
                    line-height: normal;
                }
                .cardOverlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 999;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 25px;
                }
                .card-num {
                    margin: 10px;
                    position: relative;
                    z-index: 2;
                    // color: ${(p) => p.themeColor};
                    color: #fff;
                }
                .card-mem {
                    position: relative;
                    z-index: 2;
                    background-color: ${(p) => p.themeColor};
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px 12px;
                    border-radius: 50px;
                    margin: 10px;
                    margin-top: 80px;
                    opacity: 0.8;
                }
            }
            .main-price {
                text-align: center;
                .used {
                    margin-top: 20px;
                    color: ${(p) => p.themeColor};
                    font-weight: 600;
                    font-size: 16px;
                    span {
                        font-size: 12px;
                        color: gray;
                        margin-right: 10px;
                    }
                }
                .price {
                    /* margin-top: 10px; */
                    font-size: 25px;
                    font-weight: 500;
                    color: ${(p) => p.themeColor};
                }
                .add-money {
                    font-size: 12px;
                    line-height: 14px;
                    align-items: center;
                    display: flex;
                    border: 1px solid ${(p) => p.themeColor};
                    color: ${(p) => p.themeColor};
                    height: fit-content;
                    width: fit-content;
                    border-radius: 50px;
                    padding: 5px 10px;
                    background-color: #fff;
                    cursor: pointer;
                    margin-top: 15px;
                    margin-left: auto;
                    margin-right: auto;
                    svg {
                        margin-top: 2px;
                        margin-right: 5px;
                    }
                    p {
                        margin: 0px;
                    }
                }
            }
        }
        .tab-section {
            display: flex;
            justify-content: center;
            grid-gap: 30px;
            color: ${(p) => p.themeColor};
            color: #9daaae;
            font-size: 16px;
            font-weight: 500;
            margin-top: 22px;
            cursor: pointer;
            padding-bottom: 8px;
            .menu-active {
                // border-bottom: 2px solid ${(p) => p.themeColor};
                color: ${(p) => p.themeColor};
                font-weight: 600;
                position: relative;
                &:after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 3px;
                    bottom: -8px;
                    left: 0;
                    border-radius: 6px 6px 0px 0px;
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .detail-section {
            background-color: white;
            border-radius: 25px 25px 0 0;
            padding: 32px 20px 0;
            .layout-timeline {
                height: 60vh;
                overflow: scroll;
                @media (max-width: 400px) {
                    height: 30vh;
                }
                .title-timeline {
                    color: ${(p) => p.themeColor};
                    padding-bottom: 8px;
                    font-size: 18px;
                    margin-bottom: 16px;
                    border-bottom: 1px solid ${(p) => p.themeColor};
                }
                .layout-header-timeline {
                    display: flex;
                    justify-content: space-between;
                    padding-right: 20px;
                    align-items: center;
                    .layout-timedate-timeline {
                        span {
                            color: ${(p) => p.themeColor};
                            font-size: 14px;
                            position: relative;
                            margin-right: 4px;
                            padding-right: 4px;
                            &:after {
                                content: "";
                                width: 1px;
                                height: 12px;
                                position: absolute;
                                right: -1px;
                                top: 50%;
                                transform: translateY(-50%);
                                background-color: #9daaae;
                            }
                            &:last-child {
                                &:after {
                                    display: none;
                                }
                            }
                        }
                    }
                    .layout-cash-timeline {
                        color: ${(p) => p.themeColor};
                        font-size: 14px;
                        font-weight: 500;
                    }
                }
                .detail-timeline {
                    padding: 16px;
                    background-color: #f2f5f9;
                    border-radius: 16px;
                    p {
                        color: ${(p) => p.themeColor};
                        font-size: 14px;
                        font-weight: 500;
                        margin-bottom: 6px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
                .ant-collapse {
                    background-color: #fff;
                    border: none;
                    .ant-collapse-item {
                        border: none;
                        position: relative;
                        &:after {
                            content: "";
                            width: 8px;
                            height: 8px;
                            border-radius: 16px;
                            background-color: #9daaae;
                            position: absolute;
                            top: 20px;
                            left: 0px;
                        }
                        &:before {
                            content: "";
                            width: 1px;
                            height: 100%;
                            border-right: 1px dashed #9daaae;
                            top: 20px;
                            left: 4px;
                            position: absolute;
                        }
                        &:last-child {
                            &:before {
                                display: none;
                            }
                        }
                    }
                    .ant-collapse-arrow {
                        right: 16px;
                        left: auto;
                    }
                    .ant-collapse-header {
                        padding-left: 24px;
                        .ant-collapse-arrow {
                            svg {
                                transform: rotate(90deg) !important;
                            }
                        }
                    }
                    .ant-collapse-item-active {
                        .ant-collapse-arrow {
                            svg {
                                transform: rotate(270deg) !important;
                            }
                        }
                    }
                    .ant-collapse-content {
                        border: none;
                    }
                }
            }
            .menu-section {
                border-top: 1px solid #9daaae75;
                height: 70vh;
                .menu-item {
                    border-bottom: 1px solid #9daaae75;
                    display: flex;
                    justify-content: space-between;
                    padding: 16px 0;
                    .icon-name {
                        cursor: pointer;
                        display: flex;
                        grid-gap: 8px;
                        color: ${(p) => p.themeColor};
                        font-weight: 600;
                        p {
                            margin-bottom: 0;
                        }
                    }
                    .switch-link {
                        display: flex;
                        grid-gap: 5px;
                        align-items: center;
                        color: #5b835d;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                    }
                    svg {
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        padding-top: 12px;
    }

    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;

        position: fixed;
        bottom: 40px;
        width: 440px;
        max-width: 100vw;
        display: flex;
        justify-content: space-around;

        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        .header-name {
            color: ${(p) => p.themeColor};
            font-size: 18px;
            font-weight: 600;
        }
    }
    .content {
        width: 480px;
        max-width: 100vw;
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px 16px 0 0;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .input-section {
            padding: 0px 20px;
            padding-bottom: 20px;
            color: ${(p) => p.themeColor};
            .title {
                margin-top: 15px;
                margin-bottom: 5px;
            }
            .card-input {
                padding: 25px 10px;
                border-radius: 15px;
            }
            .add-btn {
                color: white;
                background-color: ${(p) => p.themeColor};
                border-radius: 30px;
                width: 100%;
                margin: 30px 0;
                height: 60px;
            }
        }
    }
`;

const StyleTransfer = styled.div<{ themeColor: string }>`
    .card-section {
        display: flex;
        border-bottom: 1px solid #9daaae;
        align-items: center;
        gap: 12px;

        .card-img {
            width: 120px;
            height: 80px;
            object-fit: cover;
            border-radius: 15px;
            margin: 10px;
        }
        p {
            color: ${(p) => p.themeColor};
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 0;
        }
    }
    .active-trans {
        background-color: #f4f4f7;
        background-image: url(../../images/ic-select-transfer.svg);
        background-repeat: no-repeat;
        background-position: 95% center;
        background-size: 24px;
    }
    .trans-btn {
        color: white;
        background-color: ${(p) => p.themeColor};
        width: 100%;
        border-radius: 500px;
        height: 48px;
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .show-card-section {
        display: grid;
        grid-template-columns: 40% 10% 40%;
        grid-gap: 20px;
        img {
            width: 100%;
            height: 110px;
            object-fit: cover;
            border-radius: 6px;
        }
        .img-div {
            text-align: center;
            margin-bottom: 20px;
            p {
                color: ${(p) => p.themeColor};
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 0;
                margin-top: 10px;
            }
        }
        .tran-circle {
            display: flex;
            justify-content: center;
            svg {
                margin-top: 35px;
            }
        }
    }
    .input-title {
        font-size: 16px;
        color: ${(p) => p.themeColor};
    }
`;
const StyledPopupUnlink = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 26px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        margin-bottom: 20px;
        .textTitle {
            color: ${(p) => p.themeColor};
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .textDesc {
            color: var(--Text-2, #9daaae);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
        .bottomLay {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;
            margin-top: 20px;
            gap: 20px;
        }
        .btnClose {
            display: flex;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            flex: 1 0 0;
            border-radius: 90px;
            border: 1px solid;
            border-color: ${(p) => p.themeColor};
            background: var(--On-background-3, #fff);
            color: ${(p) => p.themeColor};
        }
        .btnConfirm {
            display: flex;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            flex: 1 0 0;
            border-radius: 90px;
            background: ${(p) => p.themeColor};
            color: #fff;
            border: none;
        }
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;
const Content = styled.div`
    text-align: center;
    color: white;
`;

const Logo = styled.img`
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
`;

const Text = styled.p`
    font-size: 14px;
    color: white;
    font-weight: 700;
`;
const TextCancel = styled.p`
    font-size: 10px;
    color: white;
    font-weight: 700;
`;
const StyledPopupPaymentSuccess = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 45px 28px 28px;
        border-radius: 26px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .text-order {
            font-size: 12px;
            line-height: 15px;
            color: #525257;
            margin-bottom: 5px;
            text-align: center;
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: #336c51;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            color: #946037 !important;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
`;
